module.exports = __webpack_public_path__ + "img/HIIT-Formula-Infographic-1.078f45ce.jpg";